<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7">
    <div class="header">
      <h1 class="title">{{ $t(template.snsTitle) }}</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideSns"></p>
    </div>
    <div class="body">
      <v-form ref="form" @submit.prevent>
        <v-row class="mt-8" v-for="(rows, idx) in snsIntros" :key="'sns' + idx">
          <v-col
            :cols="12 / rows.length"
            v-for="(item, i) in rows"
            class="mt-2 btn-post-wrap"
            :key="'costom' + i"
          >
            <i-text-field
              v-maxlength="'url_info'"
              v-model="item.value"
              :label="item.label"
              outlined
              dense
              hide-details="auto"
              @blur="save(idx, i)"
              :readonly="isReadonly"
            ></i-text-field>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>
<script>
import { snack } from '@/plugins/dialog/api';
export default {
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    snsIntros: [],
    alert: false,
  }),
  methods: {
    setting: function() {
      this.snsIntros = [];
      var rows = [];

      for (let i = 1; i <= 10; i++) {
        let preName = 'snsIntro' + i;

        if (this.template[preName] && this.template[preName + 'Yn'] == 'Y') {
          let obj = {
            label: this.template[preName] ? this.template[preName] : '',
            name: preName,
            value: this.desc(preName),
          };

          rows.push(obj);
          if (rows.length == 3) {
            this.snsIntros.push(rows);
            rows = [];
          }
        }
        if (i == 10 && rows.length > 0) this.snsIntros.push(rows);
      }
    },
    desc: function(preName) {
      let id = '';
      if (this.info && this.info.snses) {
        const e = this.info.snses.find(e => e.id.cvColumn == preName);
        id = e.urlInfo;
      }
      return id;
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function(idx, i) {
      const id = {
        annoId: this.$route.params.annoId,
        cvColumn: this.snsIntros[idx][i].name,
      };
      const p = {
        id: id,
        urlInfo: this.snsIntros[idx][i].value,
      };

      this.$emit('save', p, 'sns');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('CUSTOM INFO SAVE FAIL');
      } else {
        snack.info(`저장되었습니다.`);
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
